import Footer from "./Common/Footer";
import Header from "./Common/Header";
import React, { useEffect } from "react";
function ManpowerOutsourcing() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="boxed_wrapper about-page">
      <div><Header /></div>

      <div
        data-elementor-type="wp-page"
        data-elementor-id={162}
        className="elementor elementor-162"
      >
          <section className="page-title centred"
        style={{ backgroundImage: "url(assets/images/shape/shape-58.png)",padding:"50px 0px 51px 0px" }}>
        <div className="auto-container">
          <div className="content-box">
            <div
              className="shape"
              style={{ backgroundImage: "url(assets/images/shape/shape-63.png)",top:"-51px" }}
            />
            <div className="title">
              <h1>Manpower Outsourcing Services
              </h1>
            </div>
          </div>
        </div>
      </section>
       <section className="about-style-four sec-pad">
      <div className="auto-container" style={{maxWidth:"1313px"}}>
        <div className="row clearfix" style={{maxHeight:"300px"}}>
          <div className="col-lg-6 col-md-12 col-sm-12 image-column">
            <div className="image_block_5">
              <div className="image-box">
                <div className="shape">
                  <div
                    className="shape-3"
                    style={{
                      backgroundImage: "url(assets/images/shape/shape-40.png)"
                    }}
                  />
                  <div
                    className="shape-4"
                    style={{
                      backgroundImage: "url(assets/images/shape/shape-40.png)"
                      ,right: "-80px"
                      ,bottom: "165px"
                    }}
                  />
                  <div
                    className="shape-5"
                    style={{
                      backgroundImage: "url(assets/images/shape/shape-41.png)"
                    }}
                  />
                </div>
                <figure className="image image-1 paroller">
                  <img src="assets/theame/images/service_Photo/hero2.png" alt="" />
                </figure>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 content-column">
            <div className="content_block_1">
              <div className="content-box ml-70">
                <div className="sec-title">
                  <h3>Flexible, Cost-Effective Workforce Solutions for Your Business</h3>
                </div>
                <div className="bold-text">
                  <p>
                  In today’s dynamic business environment, having access to the right talent at the right time is crucial for success. Our <b>Manpower Outsourcing Services</b> provide businesses with a skilled, reliable workforce without the complexities of direct hiring. Whether you need temporary staff, project-based professionals, or long-term workforce solutions, we have you covered.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-1c1efd3 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
          data-id="1c1efd3"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e51db8e"
              data-id="e51db8e"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-c0f067b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="c0f067b"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-default">
                    <div
                      className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-e27482c"
                      data-id="e27482c"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-497661a elementor-widget elementor-widget-heading bdevs-el heading"
                          data-id="497661a"
                          data-element_type="widget"
                          data-settings='{"design_style":"style_1"}'
                          data-widget_type="heading.default"
                        >
                          <div className="elementor-widget-container">
                            <div
                              className="section_title_wrapper mgsection_title-bottoms  wow fadeInUp"
                              data-wow-delay="0.3s"
                            >
                              {/* <span className="subtitle bdevs-el-subtitle">
                                Service Achievement{" "}
                              </span> */}
                              <h2 className="section-title section-title-black bdevs-el-title">
                                Our Manpower Outsourcing Solutions{" "}
                              </h2>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <div
                  className="elementor-element elementor-element-0509cdf elementor-widget elementor-widget-service bdevs-el service"
                  data-id="0509cdf"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_3"}'
                  data-widget_type="service.default"
                >
                  <div className="elementor-widget-container">
                    <section className="service-achievement">
                      <div className="container">
                        <div className="row">
                          <div className="col-xxl-12 col-xl-12 col-lg-12">
                            <div className="business-quality-group" style={{ textAlign: 'justify' }}>
                              {/* ml-30 pr-100 */}
                              <div className="business-quality wow fadeInUp" data-wow-delay="0.3s">
                                <div className="success__single d-flex megamau-success-single-3">
                                  <div className="success__single-text success__single-text2">
                                    <h5 className="success-title bdevs-el-list_title">
                                      1. Temporary & Contract Staffing
                                    </h5>
                                    <p className="bdevs-el-list_description">
                                      Need extra hands for a seasonal project, short-term workload increase, or specialized assignments? We provide qualified professionals on a temporary or contract basis, ensuring your business operates smoothly without long-term obligations.
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="business-quality wow fadeInUp" data-wow-delay="0.3s" >
                                <div className="success__single d-flex megamau-success-single-3">
                                  <div className="success__single-text success__single-text2">
                                    <h5 className="success-title bdevs-el-list_title">
                                      2. Permanent Workforce Solutions
                                    </h5>
                                    <p className="bdevs-el-list_description">
                                      Looking for highly skilled professionals for full-time positions? We source, screen, and place the best candidates, ensuring a perfect fit for your company’s culture and needs.
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="business-quality wow fadeInUp" data-wow-delay="0.3s" >
                                <div className="success__single d-flex megamau-success-single-3">
                                  <div className="success__single-text success__single-text2">
                                    <h5 className="success-title bdevs-el-list_title">
                                      3. Project-Based Staffing
                                    </h5>
                                    <p className="bdevs-el-list_description">
                                      For businesses requiring skilled manpower for specific projects, we offer end-to-end project-based staffing solutions, ensuring that you have the right expertise for successful execution.
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="business-quality wow fadeInUp" data-wow-delay="0.3s" >
                                <div className="success__single d-flex megamau-success-single-3">
                                  <div className="success__single-text success__single-text2">
                                    <h5 className="success-title bdevs-el-list_title">
                                      4. Remote & Offshore Staffing
                                    </h5>
                                    <p className="bdevs-el-list_description">
                                      We provide businesses with remote professionals and offshore teams, enabling cost savings and operational efficiency while maintaining productivity.
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="business-quality wow fadeInUp" data-wow-delay="0.3s">
                                <div className="success__single d-flex megamau-success-single-3">
                                  <div className="success__single-text success__single-text2">
                                    <h5 className="success-title bdevs-el-list_title">
                                      5. Payroll & Compliance Management
                                    </h5>
                                    <p className="bdevs-el-list_description">
                                      Our manpower outsourcing services include handling payroll processing, tax deductions, compliance with labor laws, and benefits administration, so you don’t have to worry about administrative complexities.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-a190f38 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="a190f38"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-77ad68c"
              data-id="77ad68c"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-22c96bf elementor-widget elementor-widget-heading bdevs-el heading"
                  data-id="22c96bf"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="heading.default"
                >
                  <div className="elementor-widget-container">
                    <div
                      className="section_title_wrapper text-center wow fadeInUp"
                      data-wow-delay="0.3s"
                    >
                      <h2 className="msection-title bdevs-el-title">
                        <span>Industries</span> We Serve
                        {/* Popular <span>Services</span> */}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-f7eba66 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="f7eba66"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-601ea6b"
              data-id="601ea6b"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-b5f31f0 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="b5f31f0"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">

                            <img
                              decoding="async"
                              src="assets/theame/images/emp_image/trending-services-1.jpg"
                              alt="img not found"
                              style={{ height: '200px' }}
                            />

                          </div>
                          <div className="mblog__tag" style={{ color: "black" }}>


                            IT & Software Development

                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content" style={{ height: '150px' }}>
                          <p style={{ fontSize: "medium", color: "black" }}>

                            Developers, testers, designers, project managers, and IT support professionals.

                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-a8ed027"
              data-id="a8ed027"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-0745780 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  // data-id={0745780}
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">

                            <img
                              decoding="async"
                              src="assets/theame/images/emp_image/trending-services-2.jpg"
                              alt="img not found"
                              style={{ height: '200px' }}
                            />

                          </div>
                          <div className="mblog__tag" style={{ color: "black" }}>

                            {/* <i aria-hidden="true" className="far fa-folder-open" /> */}
                            Healthcare & Medical

                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content">
                          <p style={{ fontSize: "medium", color: "black" }}>

                            Nurses, healthcare assistants, medical billing experts, and telemedicine staff.

                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-905d7cb"
              data-id="905d7cb"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4f33a63 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="4f33a63"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">

                            <img
                              decoding="async"
                              src="assets/theame/images/emp_image/trending-services-6.jpeg"
                              alt="img not found"
                              style={{ height: '200px' }}
                            />

                          </div>
                          <div className="mblog__tag" style={{ color: "black", padding: "5px" }}>

                            {/* <i aria-hidden="true" className="far fa-folder-open" /> */}
                            Manufacturing & Engineering

                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content">
                          <p style={{ fontSize: "medium", color: "black" }}>

                            Skilled labour, engineers, machine operators, and quality inspectors.

                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-905d7cb"
              data-id="905d7cb"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4f33a63 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="4f33a63"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">

                            <img
                              decoding="async"
                              src="assets/theame/images/emp_image/trending-services-5.jpeg"
                              alt="img not found"
                              style={{ height: '200px' }}
                            />

                          </div>
                          <div className="mblog__tag" style={{ color: "black", padding: "5px" }}>

                            {/* <i aria-hidden="true" className="far fa-folder-open" /> */}
                            Retail & E-Commerce

                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content">
                          <p style={{ fontSize: "medium", color: "black" }}>

                            Sales associates, warehouse staff, customer service representatives

                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-601ea6b"
              data-id="601ea6b"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-b5f31f0 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="b5f31f0"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">

                            <img
                              decoding="async"
                              src="assets/theame/images/emp_image/trending-services-1.jpg"
                              alt="img not found"
                              style={{ height: '200px' }}
                            />

                          </div>
                          <div className="mblog__tag" style={{ color: "black" }}>


                            Finance & Accounting

                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content" style={{ height: '150px' }}>
                          <p style={{ fontSize: "medium", color: "black" }}>

                            Accountants, auditors, tax consultants, and back-office support.

                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-a8ed027"
              data-id="a8ed027"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-0745780 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  // data-id={0745780}
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">

                            <img
                              decoding="async"
                              src="assets/theame/images/emp_image/trending-services-2.jpg"
                              alt="img not found"
                              style={{ height: '200px' }}
                            />

                          </div>
                          <div className="mblog__tag" style={{ color: "black" }}>

                            {/* <i aria-hidden="true" className="far fa-folder-open" /> */}
                            Logistics & Supply Chain

                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content">
                          <p style={{ fontSize: "medium", color: "black" }}>

                            Warehouse personnel, drivers, inventory managers, and dispatchers.

                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-905d7cb"
              data-id="905d7cb"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4f33a63 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="4f33a63"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">

                            <img
                              decoding="async"
                              src="assets/theame/images/emp_image/trending-services-6.jpeg"
                              alt="img not found"
                              style={{ height: '200px' }}
                            />

                          </div>
                          <div className="mblog__tag" style={{ color: "black", padding: "5px" }}>

                            {/* <i aria-hidden="true" className="far fa-folder-open" /> */}
                            Hospitality & Customer Service

                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content">
                          <p style={{ fontSize: "medium", color: "black" }}>

                            Front desk executives, housekeeping staff, and call center agents.

                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-905d7cb"
              data-id="905d7cb"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4f33a63 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="4f33a63"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">

                            <img
                              decoding="async"
                              src="assets/theame/images/emp_image/trending-services-5.jpeg"
                              alt="img not found"
                              style={{ height: '200px' }}
                            />

                          </div>
                          <div className="mblog__tag" style={{ color: "black", padding: "5px" }}>

                            {/* <i aria-hidden="true" className="far fa-folder-open" /> */}
                            Fleet Maintenance & Automotive

                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content">
                          <p style={{ fontSize: "medium", color: "black" }}>

                            Fleet technicians, mechanics, vehicle inspectors, and maintenance personnel.

                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-601ea6b"
              data-id="601ea6b"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-b5f31f0 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="b5f31f0"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">

                            <img
                              decoding="async"
                              src="assets/theame/images/emp_image/trending-services-1.jpg"
                              alt="img not found"
                              style={{ height: '200px' }}
                            />

                          </div>
                          <div className="mblog__tag" style={{ color: "black" }}>


                            Cooks & Chefs

                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content" style={{ height: '150px' }}>
                          <p style={{ fontSize: "medium", color: "black" }}>

                            Chefs, sous chefs, line cooks, pastry chefs, and kitchen assistants.

                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-a8ed027"
              data-id="a8ed027"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-0745780 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  // data-id={0745780}
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}
                    <div className="mblog-pd wow fadeInUp" data-wow-delay="0.3s">
                      <div className="mblog">
                        <div className="mblog__thumb p-relative">
                          <div className="mblog__thumb-img">

                            <img
                              decoding="async"
                              src="assets/theame/images/emp_image/trending-services-2.jpg"
                              alt="img not found"
                              style={{ height: '200px' }}
                            />

                          </div>
                          <div className="mblog__tag" style={{ color: "black" }}>

                            {/* <i aria-hidden="true" className="far fa-folder-open" /> */}
                            Drivers

                          </div>
                        </div>
                        <div className="mblog__content smblog__content bdevs-el-content">
                          <p style={{ fontSize: "medium", color: "black" }}>

                            Commercial truck drivers, delivery drivers, taxi and rideshare drivers, and specialized vehicle operators.

                          </p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-905d7cb"
              data-id="905d7cb"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4f33a63 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="4f33a63"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}

                  </div>
                </div>
              </div>
            </div>
            <div
              className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-905d7cb"
              data-id="905d7cb"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-4f33a63 elementor-widget elementor-widget-post_list bdevs-el post_list"
                  data-id="4f33a63"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_2"}'
                  data-widget_type="post_list.default"
                >
                  <div className="elementor-widget-container">
                    {/* mblog area start here */}

                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>

        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-b419eac elementor-section-full_width elementor-section-height-default elementor-section-height-default"
          data-id="b419eac"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
          style={{ background: "#99d433" }}
        >
          <div className="elementor-container elementor-column-gap-default">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-1210183"
              data-id={1210183}
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <div
                  className="elementor-element elementor-element-5019c5e elementor-widget elementor-widget-cf7 bdevs-el cf7"
                  data-id="5019c5e"
                  data-element_type="widget"
                  data-settings='{"design_style":"style_4"}'
                  data-widget_type="cf7.default"
                >
                  <div className="elementor-widget-container">
                    <div className="footter__top footer__top-3 footer-bgg">
                      <div className="container">
                        <div className="row">
                          <div className="col-xl-4 col-lg-6">
                            <div
                              className="footer__subscribe-title wow fadeInUp"
                              data-wow-delay="0.3s"
                            >
                              <h2 className="big_title mb-0 msection-title mb-35" style={{ color: "black" }}>
                                Enquiry Now
                              </h2>
                            </div>
                          </div>
                          <div className="col-xl-8">
                            <div
                              className="footer__subscribe wow fadeInUp"
                              data-wow-delay="0.6s"
                            >
                              <div className="footer__subscribe-form footer__subscribe-form-2 footer__subscribe-form-3 p-relative">
                                <div
                                  className="wpcf7 no-js"
                                  id="wpcf7-f1484-p162-o1"
                                  lang="en-US"
                                  dir="ltr"
                                >
                                  <div className="screen-reader-response">
                                    <p
                                      role="status"
                                      aria-live="polite"
                                      aria-atomic="true"
                                    />
                                    <ul />
                                  </div>
                                  <form
                                    action="https://codeskdhaka.com/wp/megamau/#wpcf7-f1484-p162-o1"
                                    method="post"
                                    className="wpcf7-form init bdevs-cf7-form"
                                    aria-label="Contact form"
                                    noValidate="novalidate"
                                    data-status="init"
                                  >
                                    <div style={{ display: "none" }}>
                                      <input
                                        type="hidden"
                                        name="_wpcf7"
                                        defaultValue={1484}
                                      />
                                      <input
                                        type="hidden"
                                        name="_wpcf7_version"
                                        defaultValue="5.9.8"
                                      />
                                      <input
                                        type="hidden"
                                        name="_wpcf7_locale"
                                        defaultValue="en_US"
                                      />
                                      <input
                                        type="hidden"
                                        name="_wpcf7_unit_tag"
                                        defaultValue="wpcf7-f1484-p162-o1"
                                      />
                                      <input
                                        type="hidden"
                                        name="_wpcf7_container_post"
                                        defaultValue={162}
                                      />
                                      <input
                                        type="hidden"
                                        name="_wpcf7_posted_data_hash"
                                        defaultValue=""
                                      />
                                    </div>
                                    <p>
                                      <span
                                        className="wpcf7-form-control-wrap"
                                        data-name="email"
                                      >
                                        <input style={{ background: "white" }}
                                          size={40}
                                          maxLength={400}
                                          className="wpcf7-form-control wpcf7-email wpcf7-text wpcf7-validates-as-email"
                                          aria-invalid="false"
                                          placeholder="Email Address"
                                          defaultValue=""
                                          type="email"
                                          name="email"
                                        />
                                      </span>
                                      <br />
                                      <button className="theme-btn bdevs-el-btn" style={{ background: "black", color: "white" }}>
                                        Enquiry now
                                      </button>
                                    </p>
                                    <div
                                      className="wpcf7-response-output"
                                      aria-hidden="true"
                                    />
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div><Footer /></div>
    </div>
  );
}
export default ManpowerOutsourcing;
